<div class="is-relative">
    <form [formGroup]="form" class="content-type-form" isavFieldIndex>
        <isav-field-index></isav-field-index>

        <isav-text-input
            label="1. Title"
            formControlName="title"
            [mandatory]="true"
            tooltipKey="Page:title"
        ></isav-text-input>

        <div class="field is-horizontal">
            <div class="field-label field-label-tooltip">
                <strong class="has-text-weight-bold has-text-primary"> 2. Type </strong>
                <isav-tooltip-display tooltipKey="Page:locationType"></isav-tooltip-display>
            </div>
            <div
                class="field-body"
                role="radiogroup"
                aria-label="Whether created page should be internal page or an external page (link to another page) or displayed on landing page as card"
            >
                <div class="control mr-2">
                    <label class="radio">
                        <input type="radio" [formControl]="type" value="internal" />
                        Internal page
                    </label>
                </div>
                <div class="control mr-2">
                    <label class="radio">
                        <input type="radio" [formControl]="type" value="external" />
                        External page
                    </label>
                </div>
                <div class="control mr-2">
                    <label class="radio">
                        <input
                            type="radio"
                            value="card"
                            readonly
                            disabled
                            [checked]="type.value === 'card'"
                        />
                        Landing page card
                    </label>
                </div>
            </div>
        </div>

        <isav-radio-input
            label="3. Require authentication"
            formControlName="requireAuthentication"
            tooltipKey="Page:requireAuthentication"
        ></isav-radio-input>

        <ng-container *ngIf="type.value === 'external'">
            <isav-link-input
                label="4. External link"
                formControlName="externalLink"
                [mandatory]="true"
                tooltipKey="Page:externalLink"
            ></isav-link-input>
        </ng-container>

        <ng-container *ngIf="type.value === 'internal'">
            <isav-image-form
                label="4. Image"
                formControlName="image"
                tooltipKey="Page:image"
                property="image"
                [contentIri]="value['@id']"
            ></isav-image-form>

            <isav-document-input
                label="5. Attachments"
                formControlName="attachments"
                tooltipKey="Page:attachments"
                [multiple]="true"
            ></isav-document-input>

            <isav-content-editor
                label="6. Body"
                formControlName="body"
                tooltipKey="Page:body"
                property="body"
                [iri]="value['@id']"
            ></isav-content-editor>
        </ng-container>

        <ng-container *ngIf="type.value === 'card'">
            <isav-link-input
                label="3. Title link"
                formControlName="externalLink"
                tooltipKey="Page:externalLink"
            ></isav-link-input>

            <div class="field is-horizontal mb-2">
                <div class="field-label field-label-tooltip">
                    <label class="has-text-weight-bold has-text-primary">4. Icon</label>
                    <isav-tooltip-display tooltipKey="Page:logoType"></isav-tooltip-display>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control">
                            <isav-select formControlName="logoType" placeholder="Select icon">
                                <isav-option
                                    *ngFor="let option of logoTypeOptions"
                                    [value]="option.value"
                                >
                                    <span class="mr-2">{{ option.text }}</span>
                                    <isav-icon [icon]="option.icon"></isav-icon>
                                </isav-option>
                            </isav-select>
                        </div>
                    </div>
                </div>
            </div>

            <isav-content-editor
                label="5. Body"
                formControlName="body"
                tooltipKey="Page:body"
                property="body"
                [iri]="value['@id']"
            ></isav-content-editor>
        </ng-container>

        <div class="is-flex is-space-between">
            <isav-go-to-view [disabled]="value.locationType === 4 || !!value.externalLink"
                >Back to view</isav-go-to-view
            >
            <div class="buttons is-right">
                <ng-content></ng-content>
                <button type="button" isavBtn color="danger" class="ml-2" (click)="onDelete()">
                    Delete
                </button>
                <button
                    *ngIf="value.draft"
                    isavBtn
                    color="primary"
                    type="button"
                    [disabled]="!isValid"
                    (click)="onPublish()"
                >
                    Publish
                </button>
                <button
                    *ngIf="!value.draft"
                    isavBtn
                    color="danger"
                    type="button"
                    (click)="onUnpublish()"
                >
                    Unpublish
                </button>
                <button
                    type="button"
                    isavBtn
                    color="success"
                    [disabled]="!value.draft &&!isValid"
                    (click)="onSave()"
                >
                    Save
                </button>
            </div>
        </div>
    </form>
</div>
